'use client';

import Image from 'next/image';
import { useEffect, useState } from 'react';
import { LocationHydration } from 'stores/LocationStore';
import { CollectionHighlighted } from 'searchCollection';
import { CLASS_TRACKING_GTM, MATRIX_TYPE } from 'constants/index';
import { createPropsToTrackingMatrix } from 'components/Integration/createPropsToTrackingMatrix';
import { getMainUrl } from 'utils/misc';
import LocationButton from '../../../LocationButton/LocationButton';
import * as styles from './HeaderFilters.css';
import { categoriesFilters } from './categoriesFilters';
import { getHighlightedCollections } from '../../../utils/getHighlightedColletions';

interface HeaderFiltersProps {
  locationHydration: LocationHydration;
  isNavbarCollapsed?: boolean;
  variant?: 'default' | 'primary' | 'dark';
}

function HeaderFilters({ locationHydration, variant = 'primary', isNavbarCollapsed = false }: HeaderFiltersProps) {
  const [categories, setCategories] = useState<CollectionHighlighted[]>([]);

  useEffect(() => {
    const loadCategories = async () => {
      const highlighted = await getHighlightedCollections();
      setCategories(highlighted.length ? highlighted : categoriesFilters);
    };

    loadCategories();
  }, []);

  return (
    <div className={styles.container}>
      <div className={`${styles.filtersContainer} ${isNavbarCollapsed && styles.filtersContainerCollapsed}`}>
        <LocationButton selectedLocation={locationHydration.selectedLocation} variant={variant} isNavbarCollapsed={isNavbarCollapsed} />
        {categories?.map((category, index) => {
          const { dataCreative } = createPropsToTrackingMatrix(index, {
            trackingPrefix: MATRIX_TYPE.MATRIX,
            matrizTemplate: MATRIX_TYPE.HOME,
            templateType: 'highlight-category',
            cardType: 'collection-card',
            dataLocation: locationHydration.selectedLocation,
          });

          return (
            <a
              href={getMainUrl() + category.link}
              key={category.label}
              className={`${CLASS_TRACKING_GTM.COLLECTION_CARD} ${styles.category}`}
              data-bannerid={category.link}
              data-name={category.label}
              data-creative={dataCreative}
            >
              <Image src={category.icon} alt={category.label} width="24" height="24" />
              {category.label}
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default HeaderFilters;
